import { render, staticRenderFns } from "./Schritt3.vue?vue&type=template&id=482f9ab1&"
import script from "./Schritt3.vue?vue&type=script&lang=js&"
export * from "./Schritt3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports